const About: React.FC = () => {
	return <>Not found</>;
};

export default About;
